'use client';

import { c as _c } from "react/compiler-runtime";
import { queryClient } from '@module/queries';
import { QueryErrorHandlerBridge } from '@module/queries/QueryErrorHandlerBridge';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
function TanstackQueryProvider(t0) {
  const $ = _c(4);
  const {
    children
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <QueryErrorHandlerBridge confirmText={"\uD655\uC778"} />;
    t2 = <ReactQueryDevtools initialIsOpen={false} position="left" buttonPosition="bottom-left" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children) {
    t3 = <QueryClientProvider client={queryClient}>{children}{t1}{t2}</QueryClientProvider>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
export default TanstackQueryProvider;